import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_CLASSROOMOWNED,
  DELETE_CLASSROOMOWNED,
  GET_CLASSROOMSOWNED,
  GET_AVAILABLE_CLASSROOMSOWNED,
  GET_CLASSROOMOWNED,
  UPDATE_CLASSROOMOWNED,
} from '@/queries/modules/class-room/classRoomOwned';

//
// initial state
const state = {
  classRoomOwned: {
    id: '',
    inUseClassRoomQty: null,
    availableClassRoomQty: null,
    maxClassRoomQty: null,
    capacity: null,
    startDate: '',
    endDate: '',
    classRoomTypeId: '',
  },
  classRoomsOwned: [],
  availableClassRoomsOwned: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setClassRoomsOwned: (state, payload) => {
    state.classRoomsOwned = payload ? payload : [];
  },
  setAvailableClassRoomsOwned: (state, payload) => {
    state.availableClassRoomsOwned = payload ? payload : [];
  },
  setClassRoomOwned: (state, payload) => {
    state.classRoomOwned = payload;
  },
  setSelectedClassRoomOwned: (state, payload) => {
    state.classRoomOwned = {...payload};
  },
  clearSelectedClassRoomOwned: (state) => {
    state.classRoomOwned = {
      id: '',
      inUseClassRoomQty: null,
      availableClassRoomQty: null,
      maxClassRoomQty: null,
      capacity: null,
      startDate: '',
      endDate: '',
      classRoomTypeId: '',
    }
  }
};

//
// actions
const actions = {
  getClassRoomsOwned: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_CLASSROOMSOWNED,
        fetchPolicy: 'network-only'
      })
      .then(({data}) => {
        commit('setClassRoomsOwned', data.getClassRoomsOwned);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getAvailableClassRoomsOwned: async ({commit}, useState = true) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          query: GET_AVAILABLE_CLASSROOMSOWNED,
          fetchPolicy: 'network-only'
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.availableClassRoomsOwned;
      }else{
        if(useState){
          commit('setAvailableClassRoomsOwned', data.getAvailableClassRoomsOwned);
        }
        commit('setSuccess', null);
        return data.getAvailableClassRoomsOwned
      }

    } catch (e) {
      commit('setError', error(e));
      return state.availableClassRoomsOwned;
    }

  },
  getClassRoomOwned: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_CLASSROOMOWNED,
        variables: {
          id: id
        }
      })
      .then(({data}) => {
        commit('setClassRoomOwned', data.getClassRoomOwned);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  addClassRoomOwned: async ({commit}, payload) => {
    commit('setProcessing', true);
    await apolloClient
      .mutate({
        mutation: ADD_CLASSROOMOWNED,
        variables: payload,
      })
      .then(({data}) => {
        const classRoomsOwned = [...state.classRoomsOwned];
        classRoomsOwned.push(data.addClassRoomOwned);
        commit('setClassRoomsOwned', classRoomsOwned);
        commit('setSuccess', newItemSuccess(data.addClassRoomOwned.classRoomType.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateClassRoomOwned: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_CLASSROOMOWNED,
        variables: payload
      })
      .then(({data}) => {
        const index = state.classRoomsOwned.findIndex(classRoomOwned => classRoomOwned.id === data.updateClassRoomOwned.id);
        const classRoomsOwned = [
          ...state.classRoomsOwned.slice(0, index),
          data.updateClassRoomOwned,
          ...state.classRoomsOwned.slice(index + 1)
        ];

        commit('setClassRoomsOwned', classRoomsOwned);
        commit('setSuccess', updateItemSuccess(data.updateClassRoomOwned.classRoomType.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteClassRoomOwned: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_CLASSROOMOWNED,
        variables: payload
      })
      .then(({data}) => {
        const index = state.classRoomsOwned.findIndex(classRoomOwned => classRoomOwned.id === data.deleteClassRoomOwned.id);
        const classRoomsOwned = [
          ...state.classRoomsOwned.slice(0, index),
          ...state.classRoomsOwned.slice(index + 1)
        ];

        commit('setClassRoomsOwned', classRoomsOwned);
        commit('setSuccess', deleteItemSuccess(data.deleteClassRoomOwned.classRoomType.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedClassRoomOwned: async ({commit}, payload) => {
    commit('setSelectedClassRoomOwned', payload);
  },
  clearSelectedClassRoomOwned: async ({commit}) => {
    commit('clearSelectedClassRoomOwned');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
